export const LOADING_PRESENTATION_BUILD = "LOADING_PRESENTATION_BUILD";
export const SUCCESS_PRESENTATION_BUILD = "SUCCESS_PRESENTATION_BUILD";
export const ERROR_PRESENTATION_BUILD = "ERROR_PRESENTATION_BUILD";
